import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

import OrdersList from './OrdersList';
import SubscriptionsList from './SubscriptionsList';
import { get, patch, _delete, post } from '../services/api';
import Loading from './Loading/Loading';

class Pupil extends Component {
  generatePromo = async () => {
    if (!window.confirm('Voulez-vous générer un code promo de 20% pour cet utilisateur ?')) return;
    try {
      const result = await post(`/admin/pupils/${this.state.pupil.email}/promo`);
      if (result && result.code) {
        window.alert(`Code Promo créé : ${result.code}\n(Réduction : ${result.couponName})`);
      } else {
        window.alert('Erreur lors de la création du code promo (voir console)');
      }
    } catch (e) {
      console.error(e);
      window.alert('Erreur technique');
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      pupil: null,
    }
  }

  componentDidMount() {
    this.fetchPupil();
  }

  fetchPupil = async () => {
    const pupil = await get(`/admin/pupils/${this.props.match.params.id}`);
    this.setState({ pupil });
  }

  changePassDate = async (date) => {
    await patch(`/admin/pupils/${this.state.pupil.email}/subscription`, {
      expirationDate: date.toISOString(),
    });
    await this.fetchPupil();
  }

  deleteSubscription = async () => {
    await _delete(`/admin/pupils/${this.state.pupil.email}/subscription`);
    await this.fetchPupil();
  }

  render() {
    const { pupil } = this.state;

    if (!pupil) return <Loading />;

    // The new API returns the user object with nested student, subscriptions, etc.
    const lastSubscription = pupil.subscriptions && pupil.subscriptions.length > 0 ? pupil.subscriptions[0] : null;

    const expiration = lastSubscription?.expirationDate;
    const passDate = expiration && !isNaN(new Date(expiration).getTime()) ? new Date(expiration) : null;

    const paymentTypes = {
      subscriptionId: { name: 'id' },
      amount: { name: 'montant (€)' },
      status: { name: 'statut' },
      createdOn: { name: 'date' },
    };

    return <div>
      <div style={{ margin: 20 }}>
        <h2>{pupil.firstName} {pupil.lastName}</h2>
        <p>{pupil.email}</p>
        <p>Numéro de téléphone: {pupil.phone}</p>

        {pupil.stripeCustomerId && (
          <div style={{ marginBottom: 10 }}>
            <a
              href={`https://dashboard.stripe.com/customers/${pupil.stripeCustomerId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: '#635bff',
                color: 'white',
                padding: '5px 10px',
                borderRadius: 4,
                textDecoration: 'none',
                fontSize: '0.9em'
              }}
            >
              Voir client Stripe
            </a>
          </div>
        )}

        <div style={{ marginBottom: 20 }}>
          <button onClick={this.generatePromo} style={{ border: 'none', background: '#38a169', color: 'white', padding: '8px 12px', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold' }}>
            Générer Code Promo (-20%)
          </button>
        </div>

        {pupil.student?.birthdate && <p>Date de naissance: {moment(pupil.student.birthdate).format('DD/MM/YYYY')}</p>}
        <p>Inscrit le: {moment(pupil.student?.createdAt).format('DD/MM/YYYY')}</p>

        <p>Abonné: {lastSubscription ? '✅' : '❌'}</p>
        {lastSubscription &&
          <span onClick={this.deleteSubscription} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Supprimer l'abonnement</span>
        }

        <p>Fin du pass: {!passDate && '❌. Ajouter un pass :'}<DatePicker dateFormat='dd-MM-yy' selected={passDate || new Date()} onChange={this.changePassDate} /></p>

        {pupil.addresses && pupil.addresses[0] && <p>Addresse: {pupil.addresses[0].numberStreet}, {pupil.addresses[0].zipCode} {pupil.addresses[0].city} ({pupil.addresses[0].complement}) </p>}

        {pupil.orders && <OrdersList orders={pupil.orders} />}
        {pupil.subscriptions && <SubscriptionsList subscriptions={pupil.subscriptions} types={paymentTypes} showAll={true} />}
      </div>
    </div>
  }
}

export default withRouter(Pupil);
